import { createContext, FC } from 'react'
import { useReducerGeneric } from '../../generic-reducer/use-reducer-generic'
import { CartState } from './cart.types'

type CartContext = {
  cart: CartState
  cartSubstitute: (path: string, part: unknown) => void
  cartAdd: (path: string, part: unknown) => void
  cartDelete: (path: string) => void
}

export const CartContext = createContext({} as CartContext)

export const cartDefaultValue: CartState = {
  fromQuotation: undefined,
  checkin: undefined,
  checkout: undefined,
  currency: 'EUR',
  resources: [],
  secretCode: undefined,
}

export const CartProvider: FC = ({ children }) => {
  const [cart, cartSubstitute, cartAdd, cartDelete] = useReducerGeneric<CartState>({
    initial_state_params: cartDefaultValue,
  })

  return <CartContext.Provider value={{ cart, cartSubstitute, cartAdd, cartDelete }}>{children}</CartContext.Provider>
}
